import React, {useCallback, useMemo} from 'react';
import {useDispatch} from 'react-redux';

import {getPaginatedRowNumber} from 'src/components/main-column';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Cell, Row} from '@pb/kit-component-table';


import {next} from '../../entitlement-drawer.slice';
import {EntitlementType as EntitlementTypes} from '../../typedef';

import type {Pagination} from 'src/openapi/admin/models/Pagination';
import type {Role} from 'src/openapi/admin/models/Role';

type Props = {
    role: Role,
    pagination: Pagination,
    index: number,
    setRoleForDeletion: (role: Role) => void,
};

export const NotAssociatedRoleRow = ({role, pagination, index, setRoleForDeletion}: Props) => {
    const dispatch = useDispatch();

    const openResource = useCallback(() => {
        dispatch(next({entitlementType: EntitlementTypes.ROLE, entitlementId: role.id}));
    }, [dispatch, role]);

    const removeGrant = useCallback(() => {
        setRoleForDeletion(role);
    }, [setRoleForDeletion, role]);

    const rowNumber = useMemo(() => (
        getPaginatedRowNumber({...pagination, index: index + 1})
    ), [pagination, index]);

    return (
        <Row>
            <Cell>{rowNumber}</Cell>
            <Cell>
                <a onClick={openResource}>
                    <EllipsisTextHint title={role.name}>
                        {role.name}
                    </EllipsisTextHint>
                </a>
            </Cell>
            <Cell>
                <BasicIconButton onClick={removeGrant} iconProps={{type: Icons.TRASH}}/>
            </Cell>
        </Row>
    );
};
